import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';

import { AuthService } from './auth.service';

/**
 * HTTP Interceptor that automatically adds the access token to requests using Amplify
 */
export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);

  // Skip authentication for certain URLs
  const skipAuthUrls = [
    '/assets/',
    // Skip for external auth URLs
    'https://cognito-idp.eu-west-2.amazonaws.com',
  ];

  const shouldSkipAuth = skipAuthUrls.some((url: string) => req.url.includes(url));

  if (shouldSkipAuth) {
    console.warn('Skipping auth for URL:', req.url);
    return next(req);
  }

  // Get the current token using Amplify's fetchAuthSession
  return from(authService.getCurrentAccessToken()).pipe(
    switchMap((token: string | null) => {
      const isMediaRequest = req.url.includes('/media');

      // Clone the request and add the authorization header if token exists
      if (token) {
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: isMediaRequest ? true : false,
        });

        // console.log('Adding Authorization header to request:', req.url);
        return next(authReq);
      }

      // If no token, proceed with original request
      return next(req);
    })
  );
};
